module.exports = __webpack_public_path__ + "static/media/dajianshan5.cc954881.jpg";